import { appHttpRequest } from '@/utils/AppHttpRequest';
import {
	IChargebackSearch,
	IChargebackDetail,
	IChargebackStatistics,
} from './vrmBillMaintenanceRoType';

class MaintenanceRoService {
	async total(searchVo: IChargebackSearch) {
		const apiUrl = '/vrm2/maintenance/total';
		return await appHttpRequest.post<IChargebackStatistics>(apiUrl, searchVo);
	}
	async one(id: string) {
		const apiUrl = `/vrm2/repair/return/findById/${id}`;
		return await appHttpRequest.get<IChargebackDetail>(apiUrl);
	}
}
export const maintenanceRoService = new MaintenanceRoService();